import { PartnerPlatform } from '../../PartnerPlatform/PartnerPlatform';
import { ReportRow } from '../ReportRow';

export interface ProductSalesReport extends ReportRow {
  productID: number;
  optionValueID?: string;
  productName: string;
  optionValueName?: string;
  brandName?: string;
  platform: PartnerPlatform;
  amount: number;
}

export const productSalesReportFromResponse = (
  responseData: any,
): ProductSalesReport => ({
  createdAt: new Date(responseData.created_at),
  productID: responseData.product_id,
  optionValueID: responseData.option_value_id,
  productName: responseData.product_name,
  optionValueName: responseData.option_value_name,
  brandName: responseData.brand_name,
  platform: responseData.platform,
  amount: responseData.amount,
});
